var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBooknow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    xmlSpace: "preserve",
    id: "home",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-house"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home-shape2",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 11.55,15.95 L 7.89,15.95 C 7.44,15.95 7.07,16.33 7.07,16.78 L 7.07,20.54 C 7.07,21 7.44,21.37 7.89,21.37 L 11.55,21.37 C 12.01,21.37 12.38,21 12.38,20.54 L 12.38,16.78 C 12.38,16.33 12.01,15.95 11.55,15.95 Z M 10.73,19.71 L 8.72,19.71 8.72,17.61 10.73,17.61 10.73,19.71 Z M 10.73,19.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-shape3",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 16.14,17.61 L 19.09,17.61 19.09,26.29 20.73,26.29 20.73,16.78 C 20.73,16.33 20.37,15.95 19.91,15.95 L 15.31,15.95 C 14.86,15.95 14.49,16.33 14.49,16.78 L 14.49,26.29 16.14,26.29 16.14,17.61 Z M 16.14,17.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-shape4",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 27.7,13.37 L 14.58,0.29 C 14.26,-0.03 13.74,-0.03 13.42,0.29 L 0.3,13.37 C 0.06,13.61 -0.01,13.97 0.11,14.28 0.24,14.59 0.54,14.79 0.88,14.79 L 3.32,14.79 3.32,26.74 C 3.33,27.41 3.89,27.96 4.57,27.95 L 23.43,27.95 C 24.11,27.96 24.67,27.42 24.68,26.74 L 24.68,14.79 27.12,14.79 C 27.46,14.79 27.76,14.59 27.88,14.28 28.01,13.97 27.94,13.61 27.7,13.38 L 27.7,13.37 Z M 23.85,13.14 C 23.4,13.14 23.03,13.51 23.03,13.96 L 23.03,26.29 4.97,26.29 4.97,13.96 C 4.97,13.51 4.6,13.14 4.15,13.14 L 2.88,13.14 14,2.05 25.12,13.14 23.85,13.14 Z M 23.85,13.14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBooknow);
export default __webpack_public_path__ + "static/media/menu_booknow.d4c404384cbeb3defc91a94aba52c48e.svg";
export { ForwardRef as ReactComponent };